import axios from 'axios';
import { SubmissionError } from 'redux-form';

import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';

// object
export const CREATE_SCHEDULE_PENDING = 'CREATE_SCHEDULE_PENDING';
export const CREATE_SCHEDULE_FAIL = 'CREATE_SCHEDULE_FAIL';
export const CREATE_SCHEDULE_SUCCESS = 'CREATE_SCHEDULE_SUCCESS';
export const UPDATE_SCHEDULE_PENDING = 'UPDATE_SCHEDULE_PENDING';
export const UPDATE_SCHEDULE_FAIL = 'UPDATE_SCHEDULE_FAIL';
export const UPDATE_SCHEDULE_SUCCESS = 'UPDATE_SCHEDULE_SUCCESS';
// objects
export const GET_SCHEDULES_PENDING = 'GET_SCHEDULES_PENDING';
export const GET_SCHEDULES_FAIL = 'GET_SCHEDULES_FAIL';
export const GET_SCHEDULES_SUCCESS = 'GET_SCHEDULES_SUCCESS';
export const CLEAR_SCHEDULES_STORE = 'CLEAR_SCHEDULES_STORE';

export const createSchedule = (params = {
  name: null,
  account: null,
  monday: null,
  tuesday: null,
  wednesday: null,
  thursday: null,
  friday: null,
  saturday: null,
  sunday: null,
  time_from: null,
  time_to: null,
  exclude_us_holidays: null,
  excluded_dates: null,
}) => async (dispatch) => {
  dispatch({
    type: CREATE_SCHEDULE_PENDING,
    payload: {},
  });
  try {
    const response = await axios.post(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/schedules/`,
      params, { withCredentials: true },
    );
    dispatch({
      type: CREATE_SCHEDULE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
    throw new SubmissionError({ name: "Server Error, can't create schedule", _error: "can't create schedule" });
  }
};


export const updateSchedule = (
  scheduleId,
  params = {
    is_primary: null,
    name: null,
    account: null,
    monday: null,
    tuesday: null,
    wednesday: null,
    thursday: null,
    friday: null,
    saturday: null,
    sunday: null,
    time_from: null,
    time_to: null,
    exclude_us_holidays: null,
    excluded_dates: null,
  },
  seamless = false,
) => async (dispatch) => {
  dispatch({
    type: UPDATE_SCHEDULE_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless inline status editing
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  try {
    const response = await axios.patch(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/schedules/${scheduleId}/`,
      params,
      { withCredentials: true },
    );
    dispatch({
      type: UPDATE_SCHEDULE_SUCCESS,
      // and this will ensure that data is in sync with backend
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const destroySchedule = scheduleId => async (dispatch) => {
  try {
    await axios.delete(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/schedules/${scheduleId}/`,
      { withCredentials: true },
    );
  } catch (error) {
    const customError = {
      message: error?.response?.data?.message,
      appError: true,
      response: {},
    };
    handleErrors(customError, dispatch);
  }
};


export const getSchedules = (
  params = {
    account__id: null,
    page: null,
  },
  seamless = false,
) => async (dispatch) => {
  dispatch({
    type: GET_SCHEDULES_PENDING,
    // we've disabled loading if 'seamless' option is present because we need seamless reloading
    payload: seamless ? { ...params, loading: false, loaded: true } : params,
  });
  const fetchUrl = `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}campaigns/schedules/`;

  try {
    const response = await axios.get(`${fetchUrl}`, { params, withCredentials: true });
    dispatch({
      type: GET_SCHEDULES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const clearSchedulesStore = () => dispatch => dispatch({
  type: CLEAR_SCHEDULES_STORE,
  payload: {},
});
